export default "__VITE_ASSET__5T28pdLR__"